import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import Draggable from 'gsap/Draggable';
import Component from '../core/component';
import Video from '../services/html5video';
import { fitTo } from '../core/utils';
/*----------------------------------------------------*/
// Constants & variables

/*----------------------------------------------------*/

var defaults = {
  name: 'slider',
  autoplay: true,
  duration: 5000,
  delay: 7000,
  $: {
    wrapper: '.slider__slides',
    items: '.slider__slide',
    contents: '.slider__contents',
    decorations: '.slider__decorations',
    navigation: '.slider__navigation'
  },
  $$: {
    content: '.slide__content',
    media: '.slide__media',
    // video: '.slide__video',
    // decoration: '.slide__decoration',
    // overtitle: '.slide__overtitle',
    title: '.slide__title',
    description: '.slide__description',
    action: '.slide__action',
    dot: '.navigation__dot'
  }
};
var properties = {
  active: 0,
  total: 0,
  minHeight: 0,
  $items: [],
  $contents: [],
  $dots: [],
  videos: [],
  decorations: [],
  props: {},
  tl: null,
  inview: false,
  paused: false,
  initialized: false,
  $nextElm: null
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Slider = /*#__PURE__*/function (_Component) {
  _inherits(Slider, _Component);

  var _super = _createSuper(Slider);

  function Slider(element) {
    var _this3;

    var _this2;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(null);

    _classCallCheck(this, Slider);

    // element
    var $element = Component.isElement(element);

    if (typeof $element === 'undefined' || !$element) {
      throw new Error('Passed element is not a valid element');
    } // options


    var opts = Object.assign(Object.create(null), defaults, options);
    _this2 = _super.call(this, opts); // properties

    Object.assign(_assertThisInitialized(_this2), Component.cloneDeep(properties));
    _this2.$element = $element; // eslint-disable-next-line prefer-rest-params

    (_this3 = _this2).init.apply(_this3, arguments);

    return _possibleConstructorReturn(_this2, _assertThisInitialized(_this2));
  }

  _createClass(Slider, [{
    key: "init",
    value: function init() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _get(_getPrototypeOf(Slider.prototype), "init", this)).call.apply(_get2, [this].concat(args)); // constants


      this.duration = parseFloat(this.options.duration / 1000).toFixed(2);
      this.delay = parseFloat(this.options.delay / 1000).toFixed(2);
      this.timers.autoplay = null;
      this.$select(this.$element);
      this.setup();
      this.initDraggable();
      this.bindEvents();
      this.scrollAnimation();
      return this;
    } // Methods
    // --------------------------------------------------

  }, {
    key: "setup",
    value: function setup() {
      var _this4 = this;

      this.total = this.$.items.length; // move slides contents in contents wrapper

      this.$.items.find(this.$$.content).each(function (i, elm) {
        _this4.$.contents.append(elm);
      });
      this.$items = this.$.items;
      this.$contents = this.$.contents.find(this.$$.content);
      this.$dots = this.$.navigation.find(this.$$.dot); // videos

      this.$element.find(this.$$.video).each(function (i, elm) {
        var $elm = $d(elm);
        var video = new Video(elm);

        _this4.videos.push(video);

        video.on('ready', function () {
          _this4.fitVideo(video);

          $elm.addClass('is-ready'); // if active slide has a video, then play it

          var $active = $elm.parents('.active');

          if ($active.length) {
            video.play();
          } else {
            video.stop();
          }
        });
      }); // decorations

      this.$element.find(this.$$.decoration).each(function (i, elm) {
        var $elm = $d(elm);

        var decoration = _this4.renderAnimation($elm);

        _this4.decorations.push(decoration);
      });
      this.$nextElm = $d(this.$element.parent().children().get(1));
    }
  }, {
    key: "initDraggable",
    value: function initDraggable() {
      // bail if already initialized
      if (this.draggable) return;

      var _this = this;

      var fakeElement = document.createElement('div');

      var _Draggable$create = Draggable.create(fakeElement, {
        type: 'x',
        lockAxis: true,
        zIndexBoost: false,
        dragClickables: true,
        allowContextMenu: true,
        minimumMovement: 10,
        edgeResistance: 0.9,
        trigger: this.$element,
        onDragEnd: function onDragEnd() {
          if (this.getDirection() === 'right') {
            _this.previous();
          } else {
            _this.next();
          }
        },
        onClick: function onClick(e) {
          // this is to prevent strange behaviors under iOS (maybe due to Fastclick)
          if (e) e.stopPropagation();
        }
      }),
          _Draggable$create2 = _slicedToArray(_Draggable$create, 1),
          draggable = _Draggable$create2[0];

      this.draggable = draggable;
    }
  }, {
    key: "start",
    value: function start() {
      this.show(this.active);
    }
  }, {
    key: "show",
    value: function show(index) {
      var _this5 = this;

      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
      // avoid reloading the same slide
      if (this.initialized && this.active === index) return; // params

      var old = index !== this.active ? this.active : false; // elements

      var newer = this.getChildren(index);
      var older = old !== false ? this.getChildren(this.active) : null; // set initialized

      if (!this.initialized) {
        this.initialized = true;
        this.$element.addClass('reveal');
      } // update active


      this.active = index; // reset old stuff

      if (this.tl) {
        this.tl.kill(); // get all nested tweens

        var tweens = this.tl.getChildren(true, true, true); // add main timeline

        tweens.push(this.tl); // force onComplete on all tweens

        tweens.forEach(function (t) {
          if (typeof t.vars.onComplete === 'function') {
            t.vars.onComplete();
          }
        }); // get previous splitTexts instances

        if (old !== false) {
          Object.keys(older.splitTexts).forEach(function (k) {
            older.splitTexts[k] = _this5.tl.splitTexts[k];
          });
        }

        this.tl = null;
      } // make sure to cancel autoplay


      this.cancelAutoplay(); // timeline

      var tl = gsap.timeline({
        paused: true,
        onComplete: function onComplete() {
          if (old !== false) {
            // reset splitTexts instances
            Object.values(older.splitTexts).forEach(function (v) {
              if (v) v.revert();
            });
            var $clearElms = [older.$overtitle, older.$title, older.$description, older.$action].filter(function (el) {
              return el.length;
            });
            gsap.set($clearElms, {
              clearProps: 'all'
            });
          }
        }
      }); // keep track of splittexts instances

      tl.splitTexts = newer.splitTexts; // videos

      if (newer.$video.length && !newer.video) {
        var video = newer.$video[0].videoapi;

        if (typeof video !== 'undefined') {
          newer.video = video;
          video.play();
        }
      }

      if (old !== false) {
        if (older.$video.length && !older.video) {
          var _video = older.$video[0].videoapi;

          if (typeof _video !== 'undefined') {
            older.video = _video;
          }
        }
      } // text animations


      if (newer.$overtitle.length) {
        newer.splitTexts.overtitle = new SplitText(newer.$overtitle, {
          type: 'chars',
          charsClass: 'char'
        });
      }

      if (newer.$title.length) {
        newer.splitTexts.title = new SplitText(newer.$title, {
          type: 'words',
          wordsClass: 'word'
        });
      }

      if (newer.$description.length) {
        newer.splitTexts.description = new SplitText(newer.$description, {
          type: 'lines, words' // linesClass: 'line',

        });
      } // older exists


      if (old !== false) {
        // reset previous applied stuff
        tl.set(newer.$media, {
          clearProps: 'all'
        }); // update old classes

        tl.add(function () {
          _this5.$items.removeClass('old');

          _this5.$contents.removeClass('old');
        });
      } // update classes


      tl.add(function () {
        _this5.$items.removeClass('active');

        _this5.$contents.removeClass('active');

        newer.$item.addClass('active');
        newer.$content.addClass('active');

        _this5.$dots.each(function (i, dot) {
          var $dot = $d(dot);

          if (i === index) {
            $dot.addClass('active');
          } else if ($dot.hasClass('active')) {
            $dot.removeClass('active');
          }
        });
      }); // older exists

      if (old !== false) {
        // apply classes
        tl.add(function () {
          older.$item.addClass('old');
          older.$content.addClass('old');
        }); // previous slide timeline

        var olderTl = gsap.timeline();
        var olderPos = '-=0.125';

        if (older.$decoration) {
          olderTl.add(function () {
            older.$decoration.setDirection(-1);
            older.$decoration.setSpeed(2);
            older.$decoration.play();
          }, 0);
          olderTl.delay(0.25);
        }

        if (older.$action.length) {
          olderTl.to(older.$action, {
            autoAlpha: 0,
            duration: 0.25,
            ease: 'expo.out'
          });
        }

        if (older.$description.length) {
          olderTl.to(older.$description, {
            autoAlpha: 0,
            duration: 0.25,
            ease: 'expo.in'
          }, olderPos);
        }

        if (older.splitTexts.title) {
          olderTl.to(older.splitTexts.title.words, {
            autoAlpha: 0,
            duration: 0.25,
            ease: 'expo.in'
          }, olderPos);
        }

        if (older.$overtitle.length) {
          olderTl.to(older.$overtitle, {
            y: '100%',
            autoAlpha: 0,
            duration: 0.25,
            ease: 'expo.in'
          }, olderPos);
        }

        olderTl.to(older.$content, {
          autoAlpha: 0
        });
        tl.add(olderTl);
      } // active slide timeline


      var newerTl = gsap.timeline();
      var newerPos = '-=0.25';
      newerTl.to(newer.$content, {
        autoAlpha: 1
      }); // decoration

      if (newer.$decoration) {
        newer.$decoration.setDirection(1);
        newer.$decoration.setSpeed(1);
        newer.$decoration.goToAndPlay(0);
      }

      if (old === false) {
        if (newer.$decoration) {
          newer.$decoration.goToAndPlay(0);
        }
      } // overtitle


      if (newer.splitTexts.overtitle && newer.splitTexts.overtitle.chars.length) {
        newerTl.set(newer.$overtitle, {
          autoAlpha: 1
        }, 0);
        newerTl.fromTo(newer.splitTexts.overtitle.chars, {
          y: '100%',
          autoAlpha: 0
        }, {
          y: '0%',
          autoAlpha: 1,
          duration: 0.5,
          stagger: 0.01,
          ease: 'expo.out'
        }, 0);
      } // title


      if (newer.splitTexts.title) {
        newerTl.set(newer.$title, {
          autoAlpha: 1
        }, 0);
        newerTl.fromTo(newer.splitTexts.title.words, {
          y: 20,
          autoAlpha: 0
        }, {
          y: 0,
          autoAlpha: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: 'expo.out'
        }, newerPos);
      } // description


      if (newer.splitTexts.description && newer.splitTexts.description.lines.length) {
        newerTl.set(newer.$description, {
          autoAlpha: 1
        }, 0);
        newerTl.fromTo(newer.splitTexts.description.lines, {
          y: '100%',
          autoAlpha: 0
        }, {
          y: '0%',
          autoAlpha: 1,
          duration: 0.5,
          stagger: 0.01,
          ease: 'expo.out'
        }, newerPos);
      } // action


      if (newer.$action.length) {
        newerTl.fromTo(newer.$action, {
          y: 20,
          autoAlpha: 0
        }, {
          y: 0,
          autoAlpha: 1,
          duration: 0.5,
          ease: 'expo.out'
        }, newerPos);
      }

      tl.add(newerTl); // label to sync transitions

      tl.add('medias', 0); // older exists

      if (old !== false) {
        // Medias
        tl.fromTo(older.$media, {
          x: '0%'
        }, {
          x: direction === 'left' ? '100%' : '-100%',
          duration: 2,
          delay: 0.1,
          ease: 'expo.inOut',
          onComplete: function onComplete() {
            // pause video
            if (older.video) {
              older.video.pause();
            }
          }
        }, 'medias');
        tl.fromTo(newer.$media, {
          x: direction === 'left' ? '-100%' : '100%' // scale: 1,

        }, {
          x: '0%',
          // scale: 1,
          duration: 2,
          ease: 'expo.inOut'
        }, 'medias');
      }

      tl.add(function () {
        if (_this5.options.autoplay) {
          _this5.autoplay();
        }
      });
      tl.to(newer.$media, {
        duration: this.duration,
        ease: 'power1.inOut',
        force3D: true
      }, 0); // start master timeline

      this.tl = tl;
      tl.play();
    }
  }, {
    key: "navigate",
    value: function navigate(e) {
      e.preventDefault();
      var $target = $d(e.target);
      var index = $target.index();
      this.show(index, 'bottom');
    }
  }, {
    key: "next",
    value: function next() {
      var active = this.active;
      var index = active;

      if (active + 1 <= this.total - 1) {
        index = active + 1;
      } else {
        index = 0;
      }

      this.show(index, 'right');
    }
  }, {
    key: "previous",
    value: function previous() {
      var active = this.active;
      var index = active;

      if (active - 1 >= 0) {
        index = active - 1;
      } else {
        index = this.total - 1;
      }

      this.show(index, 'left');
    }
  }, {
    key: "update",
    value: function update() {
      this.props.winHeight = window.innerHeight;
      this.props.elmTop = this.$element.offset().top;
      this.props.elmHeight = this.$element.outerHeight();
      this.props.parallax = this.$.wrapper.outerHeight(true);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.cancelAutoplay(true);
      this.paused = true;
    }
  }, {
    key: "resume",
    value: function resume() {
      this.paused = false;
      this.autoplay();
    }
  }, {
    key: "autoplay",
    value: function autoplay() {
      var _this6 = this;

      if (this.paused || this.total < 2) return;
      this.cancelAutoplay();
      this.timers.autoplay = gsap.to(this.$element, {
        duration: this.delay,
        onComplete: function onComplete() {
          _this6.next();
        }
      });
    }
  }, {
    key: "cancelAutoplay",
    value: function cancelAutoplay() {
      var pause = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.timers.autoplay) {
        this.timers.autoplay.kill();
        this.timers.autoplay = null;
      }
    } // Videos
    // --------------------------------------------------

  }, {
    key: "fitVideo",
    value: function fitVideo(video) {
      if (!video.initialized) {
        return;
      }

      fitTo(video.video, this.$.wrapper, {
        width: video.width,
        height: video.height
      });
    }
  }, {
    key: "fitVideos",
    value: function fitVideos() {
      var _this7 = this;

      if (this.videos.length) {
        this.videos.forEach(function (video) {
          return _this7.fitVideo(video);
        });
      }
    }
  }, {
    key: "updateVideoState",
    value: function updateVideoState() {
      // toggle video status on scroll
      var $activeVideo = this.$.items.eq(this.active).find(this.$$.video);

      if ($activeVideo.length) {
        var video = $activeVideo[0].videoapi;

        if (typeof video !== 'undefined') {
          if (this.inview && video.playing === false) {
            video.play();
          } else if (!this.inview && video.playing === true) {
            video.pause();
          }
        }
      }
    } // Helpers
    // --------------------------------------------------

  }, {
    key: "getChildren",
    value: function getChildren(index) {
      var $item = this.$items.eq(index);
      var $content = this.$contents.eq(index);
      var $decoration = this.decorations[index];
      var splitTexts = {
        overtitle: null,
        title: null,
        description: null
      };
      return {
        $item: $item,
        $content: $content,
        $decoration: $decoration,
        $media: $item.find(this.$$.media),
        $video: $item.find(this.$$.video),
        $overtitle: $content.find(this.$$.overtitle),
        $title: $content.find(this.$$.title),
        $description: $content.find(this.$$.description),
        $action: $content.find(this.$$.action),
        splitTexts: splitTexts
      };
    }
  }, {
    key: "renderAnimation",
    value: function renderAnimation(decoration) {
      var animation;

      if (!decoration.hasClass('slide__decoration--empty')) {
        animation = loadAnimation({
          container: decoration[0],
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: "../app/themes/centre-chore/static/lottie/shape-".concat(decoration.data('color'), "_2-").concat(decoration.data('lottie'), ".json")
        });
        animation.goToAndStop(0);
      } else {
        animation = null;
      }

      return animation;
    }
  }, {
    key: "scrollAnimation",
    value: function scrollAnimation() {
      var start = 'top bottom';
      var end = this.$element.data('type') !== 'hero' ? 'bottom bottom-=100px' : 'bottom top';
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.$element,
          start: start,
          end: end,
          scrub: 1
        }
      });
    } // Events
    // --------------------------------------------------

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this8 = this;

      // global
      this.app.on('enter', this.start, this);
      this.app.on('resize', this.onResize, this); // observer

      this.bounds.intersection = this.onIntersection.bind(this);
      var observer = new window.IntersectionObserver(this.bounds.intersection, {
        root: null,
        rootMargin: '0px 0px',
        threshold: 0
      });
      observer.observe(this.$element[0]);
      this.observer = observer; // prevs & next

      this.bounds.navigate = this.navigate.bind(this); // navigation

      var _iterator = _createForOfIteratorHelper(this.$dots),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var dot = _step.value;
          dot.addEventListener('click', function (e) {
            return _this8.bounds.navigate(e);
          });
        } // pause autoplay when hovering slider clickable elements

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (this.options.autoplay === true) {
        this.bounds.pause = this.pause.bind(this);
        this.bounds.resume = this.resume.bind(this);
        this.$element.find(this.$$.action).on('mouseenter', this.bounds.pause);
        this.$element.find(this.$$.action).on('mouseleave', this.bounds.resume);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.fitVideos();
      this.update();
    }
  }, {
    key: "onIntersection",
    value: function onIntersection(entries) {
      var entry = entries[0];

      if (entry.intersectionRatio > 0) {
        if (!this.inview) this.inview = true;
        if (this.paused) this.resume();
      } else {
        if (this.inview) this.inview = false;
        if (!this.paused) this.pause();
      }
    }
  }]);

  return Slider;
}(Component);

export { Slider as default };

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}